export const navigation = [
  { name: 'Forside', href: '/' },
  { name: 'Menukort', href: '/menukort' },
  { name: 'Frokostordning', href: '/frokostordning' },
  { name: 'Vores Madkultur', href: '/madkultur' },
  { name: 'Kontakt', href: '/kontakt' },
];

export const siteData = {
  company: {
    name: 'BANHMI&BOWL',
    address: 'Rimmensgade 2B, 9900 Frederikshavn',
    phone: '20 16 14 69',
    email: 'banhmibowl@mail.com',
    cvr: '18506602',
    openingHours: [
      { day: 'Mandag - Lørdag', hours: '11:00 - 20:00' },
      { day: 'Søndag', hours: 'Lukket' },
    ],
    facebookUrl: 'https://www.facebook.com/profile.php?id=61572094626826',
    orderUrl: 'https://banh-mi-bowl-9900.shoplocal.dk/',
  },
  hero: {
    title: 'Autentisk Vietnamesisk Street Food',
    subtitle: 'Oplev smagen af Vietnam med vores friske Banh Mi og farverige bowls i hjertet af Frederikshavn.',
    image: 'https://assets.auxodev.dk/assets/eaff47c2-4c55-4355-8653-21b1b19ca1e6/7031f56f-b22d-43e1-83a8-2e85008fdd45.jpg',
  },
  menu: {
    title: 'Vores Menukort',
    description: '',
    categories: [
      {
        name: 'Bánh Mì',
        items: [
          { 
            name: 'Klassisk Bánh Mì', 
            description: 'Autentisk vietnamesisk sandwich med bánh mì mayo, syltede gulerødder, koriander, chili og friske forårsløg.\nServeres i friskbagt surdejsbaguette fra Madsen Bageri.', 
            price: '78 kr.',
            optionBoxes: [
              {
                title: 'Vælg mellem:',
                items: [
                  'Klassisk svinekød char xiu',
                  'Kylling char xiu',
                  'Grillet marineret svinekød',
                  'Marineret oksekød +10 kr.'
                ]
              },
              {
                title: 'Vælg mellem ekstra sovs 12 kr.:',
                items: [
                  'Signatur sovs',
                  'Fiskesovs',
                  'Peanuts sovs',
                  'Sursød sovs',
                  'Karry sovs',
                  'Sød chilisauce'
                ]
              },
              {
                title: 'Tilvalg:',
                items: [
                  'Ekstra kød 15 kr.',
                  'Ekstra oksekød 20 kr.',
                  'Ris 20 kr.',
                  'Menu med kildevand eller sodavand +10 kr.',
                  'Pose: 5 kr.'
                ]
              }
            ]
          },
          {
            name: 'Bánh Mì med krydder ribbensteg',
            description: 'Autentisk vietnamesisk sandwich med sprød og saftig krydret ribbensteg, bánh mì mayo, syltede gulerødder, koriander, chili og friske forårsløg i friskbagt surdejsbaguette fra Madsen Bageri.',
            price: '88 kr.'
          }
        ]
      },
      {
        name: 'Forårs- & Risruller',
        items: [
          {
            name: 'Hjemmelavede favoritter',
            description: 'Vælg mellem:\n• 3 stk. vietnamesiske forårsruller med svinekød og grøntsager\n• 2 stk. friske risruller med svinekød eller rejer samt peanutsauce\n• Stor sprød kinarulle med oksekød og grøntsager',
            price: '48 kr.'
          }
        ]
      },
      {
        name: 'Sprød Kinarulle',
        items: [
          {
            name: 'Kinarulle Menu',
            description: 'Stor sprød kinarulle med oksekød og grøntsager.\nServeres med ris samt karrysovs eller sur/sød sovs.\n\nEkstra sovs +12 kr.',
            price: '88 kr.'
          }
        ]
      },
      {
        name: 'Bowls',
        items: [
          {
            name: 'Friske Bowls',
            description: 'Friske bowls med ris eller risnudler, grøntsager og marineret kød. Serveres med gulerødder, spidskål, agurk, salat, forårsløg, peanuts og signaturdressing.\n\nVælg mellem:\n• Grillet marineret oksekød +10kr.\n• Grillet svinekød med 5 spice\n• Char siu kylling\n• Indbagte rejer\n• Vietnamesiske forårsruller\n• Combo med forårsruller og valgfrit kød\n\nMenu med kildevand eller sodavand +10 kr.',
            price: '88 kr.'
          },
          {
            name: 'Bowl med krydder ribbensteg',
            description: 'Frisk bowl med sprød og krydret ribbensteg, serveret med ris eller risnudler, sprøde grøntsager, forårsløg, peanuts og signaturdressing.',
            price: '98 kr.'
          }
        ]
      },
      {
        name: 'Pho Risnudelsuppe',
        items: [
          {
            name: 'Traditionel Pho',
            description: 'Traditionel vietnamesisk risnudelsuppe med klar fond, oksekød og risnudler. Langtidssimret med stjerneanis, kardemomme, løg og ingefær.\nServeres med friske krydderurter, lime, chili og mynte.',
            price: '118 kr.'
          }
        ]
      },
      {
        name: 'Vegetar – Banh Mi og Bowl',
        items: [
          {
            name: 'Bowl',
            description: 'Frisk og smagfuld vegetarisk bowl med tofu, champignon og vegetar soja. Serveres med ris eller risnudler og sprøde grøntsager.',
            price: '88 kr.'
          },
          {
            name: 'Bánh Mì',
            description: 'Autentisk vietnamesisk sandwich i sprød baguette med tofu, champignon, vegetar soja, syltede gulerødder, friske urter og bánh mì mayo.',
            price: '78 kr.'
          }
        ]
      },
      {
        name: 'Glutenfri – Bowl og Forårsruller',
        items: [
          {
            name: 'Bowl',
            description: 'Frisk og fyldig glutenfri bowl med glutenfri forårsruller, sprøde grøntsager, ris eller risnudler samt fiskesovs eller vegetar soja.',
            price: '98 kr.'
          },
          {
            name: 'Forårsruller, 3 stk.',
            description: '3 stk. sprøde glutenfri forårsruller.',
            price: '65 kr.'
          }
        ]
      },
      {
        name: 'Ekstra & Tilbehør',
        items: [
          {
            name: 'Rejechips (pose)',
            description: 'Sprøde asiatiske rejechips i pose.',
            price: '25 kr.'
          },
          {
            name: 'Sød chilisauce',
            description: 'Lækker sød chilisauce som ekstra dyp til forårsruller, risruller eller kinarulle.',
            price: '12 kr.'
          },
          {
            name: 'Ris',
            description: 'Ekstra portion dampede jasminris.',
            price: '20 kr.'
          }
        ]
      },
      {
        name: 'Drikkevarer',
        items: [
          { name: 'Coca-Cola', description: '', price: '15 kr.' },
          { name: 'Fanta', description: '', price: '15 kr.' },
          { name: 'Faxe Kondi', description: '', price: '15 kr.' },
          { name: 'Pepsi', description: '', price: '15 kr.' },
          { name: 'Sprite Zero Sugar', description: '', price: '15 kr.' },
          { name: 'Kildevand (almindelig eller med citrus)', description: '', price: '15 kr.' },
          { name: 'Faxe Kondi Booster', description: '', price: '20 kr.' },
          { name: 'Ramlösa', description: '', price: '20 kr.' },
          { name: 'San Pellegrino Appelsin', description: '', price: '20 kr.' },
          { name: 'San Pellegrino Clementina', description: '', price: '20 kr.' },
          { name: 'Monster Energy', description: '', price: '20 kr.' },
          { name: 'Soya Bean Drink', description: '', price: '20 kr.' }
        ]
      }
    ]
  },
  lunch: {
    title: 'Vietnamesisk Frokostordning',
    description: 'Tag dine medarbejdere med på en smagsrejse til Vietnam.',
    content: 'Vi tilbyder sunde, varierede og autentiske vietnamesiske frokostordninger til virksomheder. Vores menu bringer de friske smage fra Saigon direkte til jeres frokostbord.',
    features: [
      'Autentiske vietnamesiske retter',
      'Friske urter og råvarer',
      'Sund variation hver dag',
      'Levering direkte til døren',
    ],
    image: 'https://assets.auxodev.dk/assets/eaff47c2-4c55-4355-8653-21b1b19ca1e6/9912f99c-d044-4ee6-942e-bd56dce9b637.jpg',
  },
  culture: {
    title: 'Vietnamesisk Madkultur',
    description: 'Traditionelle opskrifter med kærlighed til detaljen.',
    content: 'Hos BANHMI&BOWL brænder vi for at bringe de autentiske vietnamesiske gadekøkken-oplevelser til Frederikshavn. Vi følger de stolte traditioner fra Vietnam og bruger kun de friskeste urter, sprøde grøntsager og kød af højeste kvalitet.',
    image: 'https://assets.auxodev.dk/assets/eaff47c2-4c55-4355-8653-21b1b19ca1e6/7c9b856b-79c3-4135-8a03-c27e0ddc8f60.jpg',
  }
};
